import { GenericService } from '@/services/api/generic.service';
export class JourneyPrescriptionService extends GenericService {
    constructor(patientId, journeyId) {
        super(`/menicon/v1/patients/${patientId}/journeys/${journeyId}/prescriptions`);
    }
}
